import { Button, ChoiceList, Popover } from "@shopify/polaris";
import React, { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ShipmentLogStatus } from "src/graphql/codegen_graphql";

interface Props {
  status: ShipmentLogStatus[];
  setStatus: (value: ShipmentLogStatus[]) => void;
}

const OptionStatus = [
  {
    label: "Pending",
    value: "PENDING",
  },
  {
    label: "Shipped",
    value: "SHIPPED",
  },
  {
    label: "Pick Up",
    value: "PICKED_UP",
  },
  {
    label: "Departed",
    value: "DEPARTED",
  },
  {
    label: "Arrived at Shipper",
    value: "ARRIVED_AT_SHIPPER",
  },
  {
    label: "Sent",
    value: "SENT",
  },
  {
    label: "Arrived",
    value: "ARRIVED",
  },
  {
    label: "Processing",
    value: "PROCESSING",
  },
  {
    label: "Processed",
    value: "PROCESSED",
  },
  {
    label: "Received",
    value: "RECEIVED",
  },
];

export function FilterStatus(props: Props) {
  const { t } = useTranslation();
  const [active, setActive] = useState(false);

  const toggleActive = useCallback(() => setActive(!active), [active]);

  const selectedStatus = props.status.length === 0 ? OptionStatus.map((x) => x.value) : props.status;

  useEffect(() => {
    props.setStatus(selectedStatus as ShipmentLogStatus[]);
  }, [props, selectedStatus]);

  return (
    <Popover
      activator={
        <Button size="slim" onClick={toggleActive}>
          {
            (
              <>
                <b>{t("status")}</b>
                {`: ${selectedStatus.map((x) => t(String(x).replace(/ /g, "_").toLowerCase())).join(",")}`}
              </>
            ) as any
          }
        </Button>
      }
      active={active}
      onClose={toggleActive}
    >
      <Popover.Section>
        <ChoiceList
          allowMultiple
          title
          titleHidden
          choices={OptionStatus.map((x) => {
            return {
              ...x,
              label: t(String(x.label).replace(/ /g, "_").toLowerCase()),
            };
          })}
          selected={selectedStatus}
          onChange={(v) => props.setStatus(v as ShipmentLogStatus[])}
        />
      </Popover.Section>
    </Popover>
  );
}
